/* 🤖 this file was generated by svg-to-ts */
export const matIconBedtime: {
  name: 'bedtime';
  data: string;
} = {
  name: 'bedtime',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9.27 4.49c-1.63 7.54 3.75 12.41 7.66 13.8A7.993 7.993 0 0 1 12 20c-4.41 0-8-3.59-8-8 0-3.45 2.2-6.4 5.27-7.51m2.72-2.48C6.4 2.01 2 6.54 2 12c0 5.52 4.48 10 10 10 3.71 0 6.93-2.02 8.66-5.02-7.51-.25-12.09-8.43-8.32-14.97h-.35z"/></svg>`
};
